import type { RouteObject } from 'react-router-dom'
import { LoginPage } from '@/pages/LoginPage'

/**
 * Routes available when no user is signed in.
 * Add new public pages (sign up, forgot password, ...) here.
 */
export const UnauthenticatedRoutes: RouteObject[] = [
  {
    path: '/',
    element: <LoginPage />
  }
]
